"use client";
import Chart from "@/app/components/Chart";
import InvestingSignals from "@/app/components/InvestingSignals";
import { ETHPrice } from "@/lib/metrics";
import { EthPerfProof } from "@/lib/PerformanceProofSource";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import CryptoOverviewPanel from "./CryptoOverviewPanel";
import PerformanceProofChart from "./PerfomanceProofChart";
import WalletTablesRow from "./WalletTablesRow";
import UnlockSignalBanner from "./UnlockSignalBanner";

export default function EthPanel() {
  const t = useTranslations();

  return (
    <Box sx={{ flex: 1, pt: 4, px: 3, minWidth: 0 }}>
      <UnlockSignalBanner />
      <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }} id="btc-pulse">
        {t.rich("Analytics.cryptoPulse", { crypto: "ETH" })}
      </Typography>
      <CryptoOverviewPanel crypto="eth" />
      <Box
        sx={{
          display: { xs: "block", md: "flex" },
          mt: 3,
          gap: 1,
          alignItems: "stretch",
        }}>
        <InvestingSignals crypto="eth" />
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", width: { xs: "100%", md: "auto" } }}>
          <Chart metricId={ETHPrice.id} chartHeight="18rem" />
        </Box>
      </Box>
      <Box sx={{ mt: 1 }}>
        <PerformanceProofChart symbol="eth" perfProof={EthPerfProof} chartHeight="27rem" />
      </Box>
      <Box sx={{ mt: 1, mb: 11, minWidth: 0 }}>
        <WalletTablesRow symbol="eth" />
      </Box>
    </Box>
  );
}
